import pushClevertapEvent from 'clevertap/pushClevertapEvent';
import formatDate from 'clevertap/formatDate';
import { select } from 'redux-saga/effects';
import { getToggleAllDayState } from 'clevertap/hourFilter';

export const getBusinessId = state => state.moka.user.business.id;
export const getOutletId = state => state.moka.user.outlet_id[0];

const STATUSES = {
  0: 'View All',
  1: 'Completed',
  2: 'Canceled',
};

export function startTrial({ outletList, featurePrice }) {
  pushClevertapEvent('Table Management Free Trial', {
    'Num of Outlet': outletList.length,
    'Total Amount payment': featurePrice.final_price,
  });
}

export function tableReportStart({ outletId, startDate, endDate, statusIds }) {
  pushClevertapEvent('Table Report Transaction', {
    'Current Selected Outlet': outletId,
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate),
    'Current Filter Status': STATUSES[statusIds],
    'Toggle All Day': getToggleAllDayState(endDate),
  });
}

export function* tableReportExport({ outletIds, startDate, endDate }) {
  pushClevertapEvent('Table Report Export', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate),
  });
}

export function* tableVoidItemReportStart({ outletId, startDate, endDate }) {
  pushClevertapEvent('Table Void Item Report', {
    'Current Selected Outlet': outletId,
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate),
    'Toggle All Day': getToggleAllDayState(endDate),
  });
}

export function tableVoidItemReportExport({
  outletIds,
  startDate,
  endDate,
  allDay,
}) {
  pushClevertapEvent('Table Void Item Report Export', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate),
    'Toggle All Day': allDay ? 'ON' : 'OFF',
  });
}

export function tableManagementPurchaseSuccess({
  businessName,
  businessType,
  numOutlets,
  costPerOutlet,
  totalAmount,
}) {
  pushClevertapEvent('Table Management Purchase Success', {
    'Business Name': businessName,
    'Business Type': businessType,
    'Num of Outlet': numOutlets,
    'Table Management Cost Per Outlet': costPerOutlet,
    'Total Amount Payment (Revenue)': totalAmount,
  });
}

export function* tableGroupStart({ totalTableGroup }) {
  const outletId = yield select(getOutletId);
  pushClevertapEvent('Table Group Start', {
    'Current Selected Outlet': outletId,
    'Total Table Group': totalTableGroup,
  });
}

export function createTableGroupSuccess(data) {
  const { name, active } = data;
  pushClevertapEvent('Create Table Group Success', {
    'Table Group Name': name,
    'Table Group Status': active,
  });
}

export function tableGroupUpdate(data) {
  const { oldName, newName, oldStatus, newStatus, tableCount } = data;
  pushClevertapEvent('Table Group Updated', {
    'Old Name': oldName,
    'New Name': newName,
    'Old Table Group Status': oldStatus,
    'New Table Group Status': newStatus,
    'Table Count': tableCount,
  });
}

export function createTableGroupDeleted(data) {
  const { deletedName, deletedTableCount } = data;
  pushClevertapEvent('Table Group Deleted', {
    'Table Group Name': deletedName,
    'Table Count': deletedTableCount,
  });
}

export function tableGroupDuplicateConfirm(data) {
  const { name, active, numberOfTables } = data;
  pushClevertapEvent('Table Group Duplicated', {
    'Table Group Name': name,
    '(Duplicate Source) Table Status': active,
    'Table Count': numberOfTables,
  });
}

export function* addTableSuccess({ name, maxPax, shape, groupName }) {
  const outletId = yield select(getOutletId);
  pushClevertapEvent('Add Table Success', {
    'Current Selected Outlet': outletId,
    'Table Group Name': groupName,
    'Table Name': name,
    'Table Shape': shape,
    'Num of Table Pax': maxPax,
  });
}

export function* editTableSuccess(table, groupDetail) {
  const outletId = yield select(getOutletId);
  pushClevertapEvent('Edit Table Success', {
    'Current Selected Outlet': outletId,
    'Table Group Name': groupDetail.name,
    'Table Name': table.name,
    'Table Shape': table.shape,
    'Num of Table Pax': table.maxPax,
  });
}

export function* deleteTableSuccess(table) {
  const outletId = yield select(getOutletId);
  pushClevertapEvent('Delete Table Success', {
    'Current Selected Outlet': outletId,
    'Table Name': table.name,
    'Table Shape': table.shape,
    'Num of Table Pax': table.maxPax,
  });
}

export function* tableMapSaveChanges(data) {
  const { active, oldTableCount, newTableCount, movement } = data;
  pushClevertapEvent('Table Map Save Changes', {
    'Table Group Status': active,
    'Old Table Count': oldTableCount,
    'New Table Count': newTableCount,
    'Table Movement aside from Add & Delete (Yes/No)': movement,
  });
}
